import React, { Component } from "react";
import PropTypes from "prop-types";
import { browserHistory } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import UserMenu from "./UserMenu";
import * as actions from "../customer-information/customerInformationActions";

class LoginHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: false
    };
    this.showMenu = this.showMenu.bind(this);
    this.hideMenu = this.hideMenu.bind(this);
  }

  componentWillMount() {
    this.props.actions.loadCustomerInformation();
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.customerInformationError !== nextProps.customerInformationError
    ) {
      browserHistory.push(`${global.applicationPath}/error`);
    }
  }

  showMenu() {
    this.setState({
      isExpanded: !this.state.isExpanded
    });
  }

  hideMenu() {
    this.setState({
      isExpanded: false
    });
  }

  render() {
    let customerName =
      this.props.customerInformation == null ||
      this.props.customerInformation.name == null ? (
        <i className="fa fa-circle-o-notch fa-spin" />
      ) : (
        this.props.customerInformation.name
      );
    let userName = this.props.user == null ? "" : this.props.user.profile.name;

    return (
      <div
        id="user-menu-container"
        className="pull-right"
        onMouseLeave={this.hideMenu}
      >
        <UserMenu
          isVisible={this.state.isExpanded}
          signedInUser={this.props.user}
        />
        <div onMouseEnter={this.showMenu} onClick={this.showMenu}>
          <i className="fa fa-3 fa-user" />
          <div>
            <div className="text-strong"> {customerName} </div>
            <div>{userName}</div>
          </div>
        </div>
      </div>
    );
  }
}

LoginHeader.propTypes = {
  actions: PropTypes.object.isRequired,
  customerInformation: PropTypes.object,
  user: PropTypes.object,
  customerInformationError: PropTypes.string
};

function mapStateToProps(state) {
  return {
    customerInformation: state.customerInformation,
    customerInformationError: state.customerInformationError,
    user: state.oidc.user
  };
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginHeader);



// WEBPACK FOOTER //
// ./src/login/LoginHeader.js